skrilla.directive('queryUserAccounts', function () {
    return {
        templateUrl: 'directives/queryUserAccounts/queryUserAccounts.html',
        scope: {
            accounts: "=",
            systemAccounts: "=",
            currency: "=",
            key: "="
        },
        controller: function ($scope, searchService, queryService, paginationService, cacheService, currencyService, constantsService) {
            $scope.currencies = currencyService.getCurrencies();
            $scope.states = constantsService.getAustralianStates();
            $scope.reset = function () {
                $scope.query = {
                    id: "",
                    username: "",
                    email: "",
                    firstName: "",
                    lastName: "",
                    phone: "",
                    verificationStatus: "",
                    state: "",
                    signupIp: "",
                    currency: "AUD",
                    limit: 20
                };
            };

            $scope.query = cacheService.getObject("queryUserAccounts")
            if (!$scope.query) {
                $scope.reset()
            }

            searchService.get('accounts/system').then(function(response) {
                $scope.systemAccounts = response.data;
            });

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getUsersAccounts, $scope.key);
            }

            var getUsersAccounts = function () {
                cacheService.registerObject("queryUserAccounts", $scope.query)
                return searchService.get('accounts' + queryService.getQueryString($scope.query, $scope.key)).then(function (response) {
                    $scope.currency = $scope.query.currency;
                    $scope.accounts = response.data.result;
                    cacheService.registerObject("userAccountsTable", $scope.accounts);
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

            $scope.btnPress = function (keyEvent) {
                if (keyEvent.which === 13)
                    $scope.search();
            }
        }
    };
});
